import { Stack } from "@mui/material";
import { useCallback } from "react";
import type { ReportField } from "../../../../../../../api/types/svTypes.ts";
import { useBiCommonDataContext } from "../../../contexts/BiCommonDataContext.ts";
import MeasureItem from "./fields/MeasureItem.tsx";
import ItemContainer from "./ItemContainer.tsx";
import { formatMeasureCaption } from "./values/helper.tsx";

interface Props {
  fields: ReportField[];
  detailedView: boolean;
  getFieldCaption?: (field: ReportField) => string;
}

export const ViewFieldsCustomConditionsParameters = ({ fields, detailedView, getFieldCaption }: Props) => {
  const handleFormatCaption = useCallback(
    (measure: ReportField, color?: string) => {
      return formatMeasureCaption(measure, color, undefined, getFieldCaption?.(measure));
    },
    [getFieldCaption]
  );
  const { dimensions, onFieldWithCustomConditionUpdate, conditions } = useBiCommonDataContext();

  return (
    <Stack useFlexGap sx={{ gap: 1 }}>
      {fields.map((field) => (
        <ItemContainer key={field.config.guid}>
          <MeasureItem
            field={field}
            detailedView={detailedView}
            readonly={false}
            globalConditions={conditions}
            canBeRemoved={false}
            hideOptions
            formatCaption={handleFormatCaption}
            updateMeasure={onFieldWithCustomConditionUpdate}
            canToggleParameter={false}
            isReadonlyCustomLabel={true}
            onSetAutoShowItemOptionsId={undefined}
            dimensions={dimensions}
          />
        </ItemContainer>
      ))}
    </Stack>
  );
};

export default ViewFieldsCustomConditionsParameters;
